document.querySelectorAll('.nurtext a').forEach(a=>{
	if(a.pathname===location.pathname)a.classList.add('active')
})